export * from './service-call-create';
export * from './service-call-edit';
export * from './service-call-detail';
export * from './service-call-summary';
export * from './service-call-routing.module';
export * from './service-call.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/index.ts